module.exports = __webpack_public_path__ + "pc/img/paypal.be29f625.png";